__turbopack_context__.v({
  "btn": "BatchPanel-module__8mj8yW__btn",
  "btnOutline": "BatchPanel-module__8mj8yW__btnOutline",
  "btnPrimary": "BatchPanel-module__8mj8yW__btnPrimary",
  "empty": "BatchPanel-module__8mj8yW__empty",
  "head": "BatchPanel-module__8mj8yW__head",
  "headBadge": "BatchPanel-module__8mj8yW__headBadge",
  "panel": "BatchPanel-module__8mj8yW__panel",
  "queue": "BatchPanel-module__8mj8yW__queue",
  "remove": "BatchPanel-module__8mj8yW__remove",
  "row": "BatchPanel-module__8mj8yW__row",
  "stat": "BatchPanel-module__8mj8yW__stat",
  "statD": "BatchPanel-module__8mj8yW__statD",
  "statE": "BatchPanel-module__8mj8yW__statE",
  "statQ": "BatchPanel-module__8mj8yW__statQ",
  "statR": "BatchPanel-module__8mj8yW__statR",
  "subText": "BatchPanel-module__8mj8yW__subText",
  "summary": "BatchPanel-module__8mj8yW__summary",
  "summaryCost": "BatchPanel-module__8mj8yW__summaryCost",
  "toolbar": "BatchPanel-module__8mj8yW__toolbar",
  "url": "BatchPanel-module__8mj8yW__url",
  "urlInput": "BatchPanel-module__8mj8yW__urlInput",
});
